var formatNumber = function(n){
    n = n.toString()
    return n[1] ? n : '0' + n
  }
  
  
  const computedDay = function(timeEnd,timeStart){
   let differ =  new Date(timeEnd).getTime()-new Date(timeStart).getTime();
   return parseInt(differ/1000/60/60/24)+1
  }
  //获取时间戳
  const getTimes = function(time){
      return Number((new Date(time)).getTime())
  }
  const getNowTimes = function(){
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      month = month<10?'0'+month:month;
      let day = date.getDate();
      day = day<10?'0'+day:day;
      let time = year +'/'+ month +'/'+ day;
      return Number((new Date(time)).getTime())
  }
  
  //获取时间戳
  const getDay = function(flag){
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      month = month<10?'0'+month:month;
      let day = date.getDate();
      day = day<10?'0'+day:day;
      let time = year +'-'+ month +'-'+ day;
      if(flag){
          return time
      }else{
          return Number((new Date(time)).getTime())
      }
  }
  //获取明天时间戳
  const getTomorrow = function(flag){
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      month = month<10?'0'+month:month;
      let day = date.getDate()+1;
      day = day<10?'0'+day:day;
      let time = year +'-'+ month +'-'+ day;
      if(flag){
          return time
      }else{
          return Number((new Date(time)).getTime())
      }
  }
  
  const getDay2 = function(time){
      let str = time.split(' ')[0]
      
    //   console.log(str)
      
      return str
  }
  const getDay3 = function(time){
      let str = time.split(' ')[0]
      
    //   console.log(str)
      let arr = str.split('-');
      
      return {year:arr[0]+'-'+arr[1],day:arr[2]}
  }

  // 处理富文本里的图片宽度自适应
  const formatRichText = function(html) {
        if(!html){
            return ''
        }
        let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
            match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
            match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
            match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
            return match;
        });
        newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
            match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi, 'width:100%;');
            return match;
        });
        newContent = newContent.replace(/<br[^>]*\/>/gi, '');
        newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin:10px 0;"');
       return newContent;
    }
  module.exports = {
    computedDay,
    getTomorrow,
    getDay,
    getTimes,
    getNowTimes,
    getDay2,
    getDay3,
    formatRichText
  };


// WEBPACK FOOTER //
// ./src/utils/utils.js